(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class TransparentTopHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section = document.getElementById('shopify-section-header'); // id generated by Shopify on section
      this.menu = this.querySelector('.header-menu');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      const mobileMenu = this.querySelector('#mobile-menu');
      if (mobileMenu) {
        mobileMenu.addEventListener('open', this.onMobileMenuOpen.bind(this));
        mobileMenu.addEventListener('close', this.onMobileMenuClose.bind(this));
      }

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.section);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop === 0) {
        requestAnimationFrame(this.topPage.bind(this));
      } else {
        requestAnimationFrame(this.inPage.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    inPage() {
      this.menu.classList.add('header-menu-in-page');
    }

    topPage() {
      this.menu.classList.remove('header-menu-in-page');
    }

    onMobileMenuOpen() {
      this.menu.classList.add('mobile-menu-open');
    }

    onMobileMenuClose() {
      this.menu.classList.remove('mobile-menu-open');
    }
  }

  customElements.define('transparent-top-header', TransparentTopHeader);

  } catch(e) { console.error(e); }
})();
})();
